import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { TranslateService } from '@ngx-translate/core';

import { CartItemImg } from '@api/cart/cart.models';
import { ProductsHelpers } from '@api/catalog/products/products.helpers';
import { Product } from '@api/catalog/products/products.models';
import { CommonWindow } from '@core/domain/models/common-window.model';

@Injectable()
export class ProductCartService {
    public readonly oneSizeValue: string = '01';

    constructor(
        private readonly translateService: TranslateService,
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) { }

    public getImageItem(product: Product, widthImage: number): CartItemImg {
        const main = ProductsHelpers.imagesForColor(this.window, product.status.selectedColor, 'checkout', widthImage)[0].path;
        const color = ProductsHelpers.imagesForColor(this.window, product.status.selectedColor, 'colorcut', widthImage)[0]?.path;

        return {
            main,
            color,
        };
    }

    public setSizeValues(product: Product) {
        const oneSize = product.status.selectedSize.name === this.oneSizeValue;
        const sizeName = product.status.selectedSize.name === this.oneSizeValue ? this.translateService.instant('legacy.one_size') : product.status.selectedSize.name;

        return { oneSize, sizeName };
    }
}
